import UserSubscriptions from './UserSubscriptions';

export default UserSubscriptions;
